var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-badge",style:({ backgroundColor: _vm.statusInfo ? _vm.statusInfo.color : '#f00' })},[(_vm.statusInfo)?_c('span',[_vm._v(" "+_vm._s(_vm.statusInfo.name)+" ")]):_c('span',[_vm._v("----")])])
}
var staticRenderFns = []

export { render, staticRenderFns }